import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthContext, { AuthProvider } from "./Auth/AuthContext";
import { BrowserRouter } from "react-router-dom";
import RouteTracker from "./Auth/RouteTracker";
import ForbiddenPage from "./Components/Pages/ErrorPages/ForbiddenPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// --- Global PWA Listeners ---
window.addEventListener("beforeinstallprompt", (e) => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later.
  window.deferredPrompt = e;
  // Locally notify components if needed
  window.dispatchEvent(new CustomEvent("deferredPromptReady"));
});

window.addEventListener("appinstalled", () => {
  // Clear the deferredPrompt so it can be garbage collected
  window.deferredPrompt = null;
  // Update localStorage to track installation
  localStorage.setItem("pwaInstalled", "true");
  // Log for debugging
  console.log("PWA was installed");
});

// Register Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => console.log("SW registered:", reg))
      .catch((err) => console.log("SW registration failed:", err));
  });
}
// ----------------------------

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 👇 pages stay "fresh" for 5 minutes → no refetch when you come back
      staleTime: 5 * 60 * 1000,
      // keep cached pages around for 30 minutes even if unused
      gcTime: 30 * 60 * 1000,
      // don't auto-refetch on these lifecycle events
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});

// const RootApp = () => {
//   const { portalStatus } = React.useContext(AuthContext);

//   if (portalStatus === "loading") {
//     return null; // render nothing (or a loader) while context initializes
//   }

//   if (portalStatus === "forbidden") {
//     return <ForbiddenPage />;
//   }

//   return <App />;
// };

const RootApp = () => {
  const { portalStatus, portalChannels } = React.useContext(AuthContext);

  // TEMP: see what the API gave you
  console.log("portalStatus:", portalStatus);
  console.log("portalChannels:", portalChannels); // { whatsapp:1, tawk:1, telegram:0 }

  if (portalStatus === "loading")
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "#002031",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999,
        }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            border: "4px solid rgba(255,255,255,0.15)",
            borderTop: "4px solid #00f181",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{"@keyframes spin{to{transform:rotate(360deg)}}"}</style>
      </div>
    );
  if (portalStatus === "forbidden") return <ForbiddenPage />;

  // Optional: tiny dev banner to confirm toggles on-screen
  // Remove in production.
  const DevBanner = () => (
    <div
      style={{
        position: "fixed",
        bottom: 8,
        left: 8,
        padding: "6px 10px",
        fontSize: 12,
        background: "#111",
        color: "#0f0",
        borderRadius: 6,
        zIndex: 999999,
      }}
    >
      WA:{portalChannels?.whatsapp} Tawk:{portalChannels?.tawk} TG:
      {portalChannels?.telegram}
    </div>
  );

  return (
    <>
      {/* <DevBanner /> */}
      <App />
    </>
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>  // note: StrictMode can cause dev-only double effects
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouteTracker>
          <RootApp />
        </RouteTracker>
      </AuthProvider>

      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
